import React from 'react';

import { Container } from './styles';

const LayoutGroup: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export { LayoutGroup };
